const ExecType = {
  null: { variant: 'warning', name: 'NA' },
  undefined: { variant: 'warning', name: 'NA' },
  0: { variant: 'info', name: 'Шинэ' },
  F: { variant: 'success', name: 'Биелсэн' },
  P: { variant: 'success', name: 'Хэсэгчлэн биелсэн' },
  4: { variant: 'danger', name: 'Цуцалсан' },
  C: { variant: 'danger', name: 'Цуцалсан' },
  8: { variant: 'danger', name: 'Цуцалсан' },
  6: { variant: 'danger', name: 'Цуцалсан' },
  5: { variant: 'warning', name: 'replaced' },
  A: { variant: 'warning', name: 'pendingNew' },
  D: { variant: 'warning', name: 'restated' },
  E: { variant: 'warning', name: 'pendingReplace' },
  G: { variant: 'warning', name: 'tradeCorrect' },
  H: { variant: 'warning', name: 'tradeCancel' },
  I: { variant: 'warning', name: 'orderStatus' },
}

const Nationality = [
  { key: '496', value: 'mng' },
  { key: '392', value: 'jpn' },
  { key: '410', value: 'kor' },
  { key: '004', value: 'afg' },
  { key: '008', value: 'alb' },
  { key: '010', value: 'ata' },
  { key: '012', value: 'dza' },
  { key: '016', value: 'asm' },
  { key: '020', value: 'and' },
  { key: '024', value: 'ago' },
  { key: '028', value: 'atg' },
  { key: '031', value: 'aze' },
  { key: '032', value: 'arg' },
  { key: '036', value: 'aus' },
  { key: '040', value: 'aut' },
  { key: '044', value: 'bhs' },
  { key: '048', value: 'bhr' },
  { key: '050', value: 'bgd' },
  { key: '051', value: 'arm' },
  { key: '052', value: 'brb' },
  { key: '056', value: 'bel' },
  { key: '060', value: 'bmu' },
  { key: '064', value: 'btn' },
  { key: '068', value: 'bol' },
  { key: '070', value: 'bih' },
  { key: '072', value: 'bwa' },
  { key: '076', value: 'bra' },
  { key: '084', value: 'blz' },
  { key: '086', value: 'iot' },
  { key: '090', value: 'slb' },
  { key: '092', value: 'vgb' },
  { key: '096', value: 'brn' },
  { key: '100', value: 'bgr' },
  { key: '104', value: 'mmr' },
  { key: '108', value: 'bdi' },
  { key: '112', value: 'blr' },
  { key: '116', value: 'khm' },
  { key: '120', value: 'cmr' },
  { key: '124', value: 'can' },
  { key: '132', value: 'cpv' },
  { key: '136', value: 'cym' },
  { key: '140', value: 'caf' },
  { key: '144', value: 'lka' },
  { key: '148', value: 'tcd' },
  { key: '152', value: 'chl' },
  { key: '156', value: 'chn' },
  { key: '158', value: 'twn' },
  { key: '162', value: 'cxr' },
  { key: '166', value: 'cck' },
  { key: '170', value: 'col' },
  { key: '174', value: 'com' },
  { key: '175', value: 'myt' },
  { key: '178', value: 'cog' },
  { key: '180', value: 'cod' },
  { key: '184', value: 'cok' },
  { key: '188', value: 'cri' },
  { key: '191', value: 'hrv' },
  { key: '192', value: 'cub' },
  { key: '196', value: 'cyp' },
  { key: '203', value: 'cze' },
  { key: '204', value: 'ben' },
  { key: '208', value: 'dnk' },
  { key: '212', value: 'dma' },
  { key: '214', value: 'dom' },
  { key: '218', value: 'ecu' },
  { key: '222', value: 'slv' },
  { key: '226', value: 'gnq' },
  { key: '231', value: 'eth' },
  { key: '232', value: 'eri' },
  { key: '233', value: 'est' },
  { key: '234', value: 'fro' },
  { key: '238', value: 'flk' },
  { key: '242', value: 'fji' },
  { key: '246', value: 'fin' },
  { key: '250', value: 'fra' },
  { key: '254', value: 'guf' },
  { key: '258', value: 'pyf' },
  { key: '262', value: 'dji' },
  { key: '266', value: 'gab' },
  { key: '268', value: 'geo' },
  { key: '270', value: 'gmb' },
  { key: '275', value: 'pse' },
  { key: '276', value: 'deu' },
  { key: '288', value: 'gha' },
  { key: '292', value: 'gib' },
  { key: '296', value: 'kir' },
  { key: '300', value: 'grc' },
  { key: '304', value: 'grl' },
  { key: '308', value: 'grd' },
  { key: '312', value: 'glp' },
  { key: '316', value: 'gum' },
  { key: '320', value: 'gtm' },
  { key: '324', value: 'gin' },
  { key: '328', value: 'guy' },
  { key: '332', value: 'hti' },
  { key: '336', value: 'vat' },
  { key: '340', value: 'hnd' },
  { key: '344', value: 'hkg' },
  { key: '348', value: 'hun' },
  { key: '356', value: 'ind' },
  { key: '360', value: 'idn' },
  { key: '364', value: 'irn' },
  { key: '368', value: 'irq' },
  { key: '372', value: 'irl' },
  { key: '376', value: 'isr' },
  { key: '380', value: 'ita' },
  { key: '384', value: 'civ' },
  { key: '388', value: 'jam' },
  { key: '398', value: 'kaz' },
  { key: '400', value: 'jor' },
  { key: '404', value: 'ken' },
  { key: '408', value: 'prk' },
  { key: '414', value: 'kwt' },
  { key: '417', value: 'kgz' },
  { key: '418', value: 'lao' },
  { key: '422', value: 'lbn' },
  { key: '426', value: 'lso' },
  { key: '428', value: 'lva' },
  { key: '430', value: 'lbr' },
  { key: '434', value: 'lby' },
  { key: '438', value: 'lie' },
  { key: '440', value: 'ltu' },
  { key: '442', value: 'lux' },
  { key: '446', value: 'mac' },
  { key: '450', value: 'mdg' },
  { key: '454', value: 'mwi' },
  { key: '458', value: 'mys' },
  { key: '462', value: 'mdv' },
  { key: '466', value: 'mli' },
  { key: '470', value: 'mlt' },
  { key: '474', value: 'mtq' },
  { key: '478', value: 'mrt' },
  { key: '480', value: 'mus' },
  { key: '484', value: 'mex' },
  { key: '492', value: 'mco' },
  { key: '498', value: 'mda' },
  { key: '499', value: 'mne' },
  { key: '500', value: 'msr' },
  { key: '504', value: 'mar' },
  { key: '508', value: 'moz' },
  { key: '512', value: 'omn' },
  { key: '516', value: 'nam' },
  { key: '520', value: 'nru' },
  { key: '524', value: 'npl' },
  { key: '528', value: 'nld' },
  { key: '533', value: 'abw' },
  { key: '540', value: 'ncl' },
  { key: '548', value: 'vut' },
  { key: '554', value: 'nzl' },
  { key: '558', value: 'nic' },
  { key: '562', value: 'ner' },
  { key: '566', value: 'nga' },
  { key: '570', value: 'niu' },
  { key: '574', value: 'nfk' },
  { key: '578', value: 'nor' },
  { key: '580', value: 'mnp' },
  { key: '583', value: 'fsm' },
  { key: '584', value: 'mhl' },
  { key: '585', value: 'plw' },
  { key: '586', value: 'pak' },
  { key: '591', value: 'pan' },
  { key: '598', value: 'png' },
  { key: '600', value: 'pry' },
  { key: '604', value: 'per' },
  { key: '608', value: 'phl' },
  { key: '612', value: 'pcn' },
  { key: '616', value: 'pol' },
  { key: '620', value: 'prt' },
  { key: '624', value: 'gnb' },
  { key: '626', value: 'tls' },
  { key: '630', value: 'pri' },
  { key: '634', value: 'qat' },
  { key: '638', value: 'reu' },
  { key: '642', value: 'rou' },
  { key: '643', value: 'rus' },
  { key: '646', value: 'rwa' },
  { key: '654', value: 'shn' },
  { key: '659', value: 'kna' },
  { key: '660', value: 'aia' },
  { key: '662', value: 'lca' },
  { key: '666', value: 'spm' },
  { key: '670', value: 'vct' },
  { key: '674', value: 'smr' },
  { key: '678', value: 'stp' },
  { key: '682', value: 'sau' },
  { key: '686', value: 'sen' },
  { key: '688', value: 'srb' },
  { key: '690', value: 'syc' },
  { key: '694', value: 'sle' },
  { key: '702', value: 'sgp' },
  { key: '703', value: 'svk' },
  { key: '704', value: 'vnm' },
  { key: '705', value: 'svn' },
  { key: '706', value: 'som' },
  { key: '710', value: 'zaf' },
  { key: '716', value: 'zwe' },
  { key: '724', value: 'esp' },
  { key: '729', value: 'sdn' },
  { key: '732', value: 'esh' },
  { key: '740', value: 'sur' },
  { key: '744', value: 'sjm' },
  { key: '748', value: 'swz' },
  { key: '752', value: 'swe' },
  { key: '756', value: 'che' },
  { key: '760', value: 'syr' },
  { key: '762', value: 'tjk' },
  { key: '764', value: 'tha' },
  { key: '768', value: 'tgo' },
  { key: '772', value: 'tkl' },
  { key: '776', value: 'ton' },
  { key: '780', value: 'tto' },
  { key: '784', value: 'are' },
  { key: '788', value: 'tun' },
  { key: '792', value: 'tur' },
  { key: '795', value: 'tkm' },
  { key: '796', value: 'tca' },
  { key: '798', value: 'tuv' },
  { key: '800', value: 'uga' },
  { key: '804', value: 'ukr' },
  { key: '807', value: 'mkd' },
  { key: '818', value: 'egy' },
  { key: '826', value: 'gbr' },
  { key: '833', value: 'imn' },
  { key: '834', value: 'tza' },
  { key: '840', value: 'usa' },
  { key: '850', value: 'vir' },
  { key: '854', value: 'bfa' },
  { key: '858', value: 'ury' },
  { key: '860', value: 'uzb' },
  { key: '862', value: 'ven' },
  { key: '876', value: 'wlf' },
  { key: '882', value: 'wsm' },
  { key: '887', value: 'yem' },
  { key: '894', value: 'zmb' },
]

const MseShareCodes = [
  { value: 9992, text: 'Ногдол ашиг' },
  { value: 9991, text: 'Засгийн газрын бондын мөнгө' },
  { value: 9999, text: 'Бэлэн мөнгө' },
]

const AccountType = [
  { value: 'nominal', text: 'Номинал данс' },
  { value: 'mse', text: 'ҮЦТХТ' },
]

const BankIcons = [
    { value: '04', name: 'Худалдаа хөгжлийн банк', logo: 'tdbbank.png'},
    { value: '05', name: 'Хаан банк', logo: 'khanbank.png'},
    { value: '15', name: 'Голомт банк', logo: 'golomtbank.png'},
    { value: '19', name: 'Тээвэр хөгжлийн банк', logo: 'transbank.png'},
    { value: '21', name: 'Ариг банк', logo: 'arigbank.png'},
    { value: '29', name: 'Үндэсний хөрөнгө оруулалтын банк', logo: 'nibank.png'},
    { value: '30', name: 'Капитрон банк', logo: 'capitronbank.png'},
    { value: '32', name: 'Хас банк', logo: 'xacbank.png'},
    { value: '33', name: 'Чингис хаан банк', logo: 'chingisbank.png'},
    { value: '34', name: 'Төрийн банк', logo: 'statebank.png'},
    { value: '38', name: 'Богд банк', logo: 'bogdbank.png'},
    { value: '39', name: 'М банк', logo: 'mbank.png'},
]

export const colors = {
  light: {
    chart: {
      background: 'var(--rgb-body-background-color)',
      primary: 'var(--rgb-primary-color)',
      up: 'var(--rgb-system-green)',
      down: 'var(--rgb-system-red)',
      gridColor: 'var(--rgb-text-grey-color)',
    },
  },
  dark: {
    chart: {
      background: 'var(--rgb-secondary-color)',
      primary: 'var(--rgb-primary-color)',
      up: 'var(--rgb-system-green)',
      down: 'var(--rgb-system-red)',
      gridColor: 'var(--rgb-dark-grey-color)',
    },
  },
}

const FinancialCodes = {
  trading_amount : [
    { value: '10', name: '1,000,000 төгрөгөөс бага' },
    { value: '11', name: '1,000,001 - 5,000,000 төгрөг' },
    { value: '12', name: '5,000,001 - 10,000,000 төгрөг' },
    { value: '13', name: '10,000,001 - 50,000,000 төгрөг' },
    { value: '14', name: '50,000,001 - 100,000,000 төгрөг' },
    { value: '15', name: '100,000,001 - 500,000,000 төгрөг' },
    { value: '16', name: '500,000,001 - 1,000,000,000 төгрөг' },
    { value: '17', name: '1,000,000,001 төгрөгөөс их' }
  ],
  old_trading_amount : [
    { value: '1' , name: '1,000,000 төгрөгөөс бага' },
    { value: '2' , name: '1,000,001₮ - 5,000,000₮' },
    { value: '3' , name: '5,000,001₮ - 10,000,000₮' },
    { value: '4' , name: '10,000,001₮ - 50,000,000₮' },
    { value: '5' , name: '50,000,001₮ - 100,000,000₮' },
    { value: '6' , name: '100,000,001₮ - 1,000,000,000₮' },
    { value: '7' , name: '1,000,000,001₮ - 5,000,000,000₮' },
    { value: '8' , name: '5,000,000,001 төгрөгөөс их'},
  ],
  salary : [
    { value: '10', name: '1,000,000 төгрөгөөс бага' },
    { value: '11', name: '1,000,001 - 5,000,000 төгрөг' },
    { value: '12', name: '5,000,001 - 10,000,000 төгрөг' },
    { value: '13', name: '10,000,001 - 50,000,000 төгрөг' },
    { value: '14', name: '50,000,001 - 100,000,000 төгрөг' },
    { value: '15', name: '100,000,001 төгрөгөөс их' },
  ],

  old_salary : [
    { value: '1', name: '1,000,000 төгрөгөөс бага' },
    { value: '2', name: '1,000,001 - 3,000,000 төгрөг' },
    { value: '3', name: '3,000,001 - 5,000,000 төгрөг' },
    { value: '4', name: '5,000,001 төгрөгөөс их' },
  ]
}
const dateLocale = {
  locale: 'mn',
  locales: {
    mn: {
      id: 'mn',
      firstDayOfWeek: 2,
      masks: {
        L: 'YYYY-MM-DD',
        weekdays: 'WW',
      },
      translations: {
        monthNames: [
          '1-р сар',
          '2-р сар',
          '3-р сар',
          '4-р сар',
          '5-р сар',
          '6-р сар',
          '7-р сар',
          '8-р сар',
          '9-р сар',
          '10-р сар',
          '11-р сар',
          '12-р сар',
        ],
        monthNamesShort: [
          '01',
          '02',
          '03',
          '04',
          '05',
          '06',
          '07',
          '08',
          '09',
          '10',
          '11',
          '12',
        ],
        dayNames: [
          'Ням',
          'Даваа',
          'Мягмар',
          'Лхагва',
          'Пүрэв',
          'Баасан',
          'Бямба',
        ],
        dayNamesShort: ['Ням', 'Дав', 'Мяг', 'Лха', 'Пүр', 'Баа', 'Бям'],
        dayNamesShorter: ['Ня', 'Да', 'Мя', 'Лх', 'Пү', 'Ба', 'Бя'],
        dayNamesNarrow: ['Н', 'Д', 'М', 'Л', 'П', 'Б', 'Б'],
      },
    },
  },
}

export { ExecType, Nationality, MseShareCodes, dateLocale, AccountType, BankIcons, FinancialCodes }
